{
  "models": {
    "alert": "Alerta",
    "alert_plural": "Alertas",
    "analytics": "Analítica",
    "analytics_plural": "Analítica",
    "parameter": "Parámetro",
    "parameter_plural": "Parámetros",
    "node": "Nodo",
    "node_plural": "Nodos",
    "thiamis": "Thiamis",
    "thiamis_plural": "Thiamis",
    "device": "Dispositivo",
    "device_plural": "Dispositivos",
    "dashboard": "Panel de control",
    "dashboard_plural": "Paneles de control",
    "dashboard_create": "Crear Panel de control",
    "monitor": "Supervisar",
    "widget": "Widget",
    "widget_plural": "Widgets",
    "user": "Usuario",
    "user_plural": "Usuarios",
    "user_invitation": "Invitación",
    "user_invitation_plural": "Invitaciones",
    "data_point": "Punto de datos",
    "data_point_plural": "Puntos de datos",
    "node_widget": "Nodo del widget",
    "node_widget_create": "Crear Widget de Nodo",
    "node_widget_update": "Actualizar Widget de Nodo",
    "node_widget_plural": "Nodo de los widgets",
    "chart_widget": "Gráfico del widget",
    "chart_widget_create": "Crear Widget de Gráfico",
    "chart_widget_update": "Actualizar Widget de Gráfico",
    "chart_widget_plural": "Gráfico de los widgets",
    "text_widget": "Texto del widget",
    "text_widget_create": "Crear Widget de Texto",
    "text_widget_update": "Actualizar Widget de Texto",
    "text_widget_plural": "Texto de los widgets",
    "map_widget": "Mapa del widget",
    "map_widget_create": "Crear Widget de Mapa",
    "map_widget_update": "Actualizar Widget de Mapa",
    "map_widget_plural": "Mapa de los widgets",
    "heatmap_widget": "Widget de Parámetro",
    "heatmap_widget_create": "Crear Widget de Parámetro",
    "heatmap_widget_update": "Actualizar Widget de Parámetro",
    "heatmap_widget_plural": "Widgets de Parámetro",
    "wind_rose_widget": "Rosa de los Vientos",
    "wind_rose_widget_create": "Crear Widget de Rosa de los Vientos",
    "wind_rose_widget_update": "Actualizar Widget de Rosa de los Vientos",
    "wind_rose_widget_plural": "Widgets de Rosa de los Vientos",
    "connectivity_widget": "Conectividad",
    "connectivity_widget_create": "Crear Widget de Conectividad",
    "connectivity_widget_update": "Actualizar Widget de Conectividad",
    "connectivity_widget_plural": "Widgets de Conectividad",
    "distribution_widget": "Distribución",
    "distribution_widget_create": "Crear Widget de Distribución",
    "distribution_widget_update": "Actualizar Widget de Distribución",
    "distribution_widget_plural": "Widgets de Distribución",
    "table_widget": "Tablero del widget",
    "table_widget_plural": "Tablero de los widgets",
    "blocks_widget": "Bloque del widget",
    "blocks_widget_create": "Crear Widget de Bloque",
    "blocks_widget_update": "Actualizar Widget de Bloque",
    "blocks_widget_plural": "Bloque de los widgets",
    "twitter_widget": "Twitter del widget",
    "twitter_widget_plural": "Twitter de los widgets",
    "airthinx_widget_plural": "Widgets de Parámetro",
    "sensors_widget": "Sensores del widget",
    "organization": "Organización",
    "organization_plural": "Organizaciones",
    "partnership": "Asociación",
    "partnership_plural": "Asociaciones",
    "partnership_invitation": "Invitación para asociados",
    "partnership_invitation_plural": "Invitaciones para asociados",
    "message": "Mensaje",
    "message_plural": "Mensajes",
    "address": "Dirección",
    "address_plural": "Direcciones",
    "contact_info": "Información de contacto",
    "contact_info_plural": "Información de los contactos",
    "map": "Mapa",
    "map_plural": "Mapas",
    "file": "Archivo",
    "file_plural": "Archivos",
    "formation_request": "Solicitud de la organización",
    "formation_request_plural": "Solicitudes de la organización",
    "archive": "Archivo",
    "user_file": "Archivo",
    "user_file_plural": "Archivos",
    "firmware": "Firmware",
    "firmware_plural": "Firmware",
    "certificate": "Certificado",
    "certificate_plural": "Certificados",
    "api": "API",
    "api_plural": "API",
    "webhook": "Webhook",
    "webhook_plural": "Webhooks",
    "permission": "Permiso",
    "permission_plural": "Permisos"
  },
  "attributes": {
    "alert": {
      "name": "Nombre",
      "description": "Mensaje",
      "last_triggered_ts": "Última vez que se activó",
      "organization_id": "Propietario",
      "level": "Nivel de notificación",
      "rules": "Condiciones",
      "nodes": "Nodos",
      "subscriptions": "Suscriptores",
      "reactivation_time_ms": "Reactivación de la alerta",
      "activation_ts": "Fecha de activación",
      "deactivation_ts": "Fecha de desactivación",
      "status": "Estado",
      "notification_level": "Nivel de notificación",
      "notification_method": "Método de notificación"
    },
    "alert_rule": {
      "sensor": "Sensor",
      "node": "Dispositivo",
      "name": "Parámetro",
      "func": "Comparador",
      "value": "Valor"
    },
    "api": {
      "organization_id": "Organización",
      "created_at": "Creado",
      "device_scope": "Ámbito del Dispositivo",
      "last_used_at": "Última vez que se utilizó",
      "user_id": "Creado por",
      "requests": "Solicitudes",
      "_id": "Clave"
    },
    "webhook": {
      "url": "URL",
      "auth": "Autenticación",
      "nodes": "Nodos",
      "type": "Tipo"
    },
    "node": {
      "serial": "S/N",
      "name": "Nombre",
      "timezone": "Zona horaria",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "description": "Descripción",
      "reporting_interval": "Intervalo del informe",
      "is_public": "Publicado",
      "leased_to": "Rentado a",
      "shared_to": "Compartido con",
      "calibration_date": "Fecha de calibración",
      "verification_date": "Fecha de verificación",
      "calibration_certificate": "Certificado de calibración",
      "performance_verification": "Certificado de rendimiento",
      "type": "Tipo",
      "status": "Estado"
    },
    "firmware": {
      "version": "Firmware",
      "thiamis": "Thiamis",
      "channel": "Canal",
      "serials": "Números de serie",
      "status": "Estado",
      "current_units": "Unidades actuales",
      "pending_units": "Unidades pendientes"
    },
    "thiamis": {
      "serial": "S/N",
      "firmware": "F/W",
      "firmware_channel": "Canal F/W",
      "mac_address": "MAC",
      "imei": "IMEI",
      "iccid": "ICCID",
      "imsi": "IMSI",
      "wifi_bssid": "WiFi BSSID",
      "wifi_network": "Red WiFi",
      "gsm_network": "Red GSM",
      "battery": "Batería",
      "wifi_ssid": "WiFi SSID",
      "wifi_password": "Contraseña WiFi",
      "enable_battery": "Voltaje de la batería",
      "enable_led": "Estado del dispositivo",
      "led_aq": "Alertas visuales",
      "public_link": "Enlace Público",
      "enable_temperature": "Temperatura",
      "dfs": "DFS",
      "speed": "Velocidad",
      "pm_config": "Contadores de Partículas",
      "pm_bin_counters": "Contadores de Partículas Bin",
      "voc_unit": "Unidad VOC",
      "extensions": "Perfil",
      "automation_devices": "Dispositivos Conectados",
      "automation": "AQMS",
      "bluetooth_share": "Compartir Bluetooth",
      "enable_pressure": "Presión",
      "enable_humidity": "Humedad",
      "enable_gps": "GPS",
      "debug_level": "Depurar nivel",
      "debug_tags": "Depurar etiquetas",
      "rtu_status": "Estado de la UTR",
      "organization_id": "Propietario",
      "location": "Ubicación",
      "name": "Nombre",
      "model": "Modelo",
      "interval": "Intervalo del informe",
      "timezone": "Zona horaria",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "description": "Descripción",
      "reporting_interval": "Intervalo del informe",
      "is_public": "Publicado",
      "leased_to_org": "Rentado a la organización",
      "shared_to_orgs": "Compartido con las organizaciones",
      "shared_to_users": "Compartido con los usuarios",
      "type": "Tipo",
      "status": "Estado",
      "temp_f": "Temperatura en °F",
      "settings_endpoint": "Endpoint:",
      "settings_run_action": "Ejecutar Acción",
      "settings_endpoint_default": "Predeterminado",
      "settings_endpoint_custom": "Personalizado",
      "scheduler": "Programador"
    },
    "dashboard": {
      "title": "Título",
      "name": "Nombre",
      "dashboard_name": "Nombre",
      "description": "Descripción",
      "organization": "Organización"
    },
    "report": {
      "name": "Nombre",
      "description": "Descripción",
      "standard": "Estándar",
      "type": "Tipo de informe",
      "working_hours": "Horas de trabajo",
      "include_logo": " Mostrar logotipo de la organización",
      "include_logo_missing_tooltip": "Falta el logotipo de la organización. Por favor, súbelo en la página de edición de la organización.",
      "include_summary": "Incluir resumen por Noesis",
      "types": {
        "air_quality": "Calidad del aire",
        "air_quality_crp": "Calidad del aire de la cabina",
        "perimeter_monitor": "Monitoreo de perímetro",
        "aethair_cms_2567": "Aethair CMS-2567"
      },
      "standards": {
        "perimeter-custom": "Personalizado",
        "nys-der-10": "NYS DER-10 (CAMP)",
        "nj-dep-pam": "NJDEP PAM"
      },
      "node_ids": "Dispositivos"
    },
    "sensor": {
      "name": "Nombre del sensor",
      "vendor": "Proveedor",
      "sensor_type": "Sensor",
      "com_port": "Puerto COM",
      "com_type": "Tipo COM",
      "address": "Dirección",
      "serial": "S/N",
      "model": "Modelo",
      "status": "Estado",
      "measurements": "Medidas"
    },
    "node_widget": {
      "selected_data_point_ids": "Puntos de datos incluidos",
      "filtered_data_point_ids": "Puntos de datos excluidos"
    },
    "chart_widget": {
      "selected_data_point_ids": "Puntos de datos seleccionados"
    },
    "heatmap_widget": {
      "selected_data_point_id": "Parámetro"
    },
    "table_widget": {
      "timestamp": "Hora"
    },
    "data_point": {
      "name": "Nombre",
      "last_value": "Valor",
      "last_unit": "Unidad"
    },
    "organization": {
      "name": "Nombre",
      "fullname": "Nombre de la Organización",
      "member_count": "Miembros",
      "node_count": "Nodos",
      "contact": "Contacto",
      "location": "Ubicación",
      "created_at": "Registrado",
      "billing_same_as_shipping": "utilizar la misma dirección para la facturación"
    },
    "partner_organization": {
      "name": "Organización del asociado"
    },
    "partnership": {
      "org1_name": "Organización",
      "org2_name": "Asociado",
      "org2_location": "Ubicación",
      "org2_contact": "Contacto",
      "access": "Acceso"
    },
    "partnership_invitation": {
      "email": "Correo electrónico",
      "acceptance_state": "Estado",
      "inviting_organization_name": "Invitar una organización",
      "created_at": "Creado"
    },
    "user": {
      "old_password": "Contraseña anterior",
      "name": "Nombre",
      "given_name": "Nombre",
      "family_name": "Apellido",
      "email": "Correo electrónico",
      "mobile": "Teléfono celular",
      "phone": "Teléfono de la oficina",
      "temp_units": "Unidades de temperatura",
      "temp_units_both": "Ambas",
      "password": "Contraseña",
      "password_confirmation": "Confirmar la contraseña",
      "new_password": "Nueva contraseña",
      "new_password_confirmation": "Confirmar la nueva contraseña",
      "locale": "Idioma",
      "status": "Estado",
      "role": "Función",
      "contact": "Contacto",
      "company_location": "Ubicación de la empresa",
      "last_login": "Último inicio de sesión",
      "active": "Última actividad",
      "address_country": "País",
      "address_zip_code": "Código Postal",
      "address_city": "Ciudad",
      "address_state": "Estado",
      "address_street": "Calle",
      "job_title": "Cargo",
      "organization_level": "Nivel de la organización"
    },
    "message": {
      "subject": "Mensaje",
      "body": "Contenido",
      "type": "Tipo",
      "time": "Hora"
    },
    "user_invitation": {
      "email": "Correo electrónico",
      "organization": "Organización",
      "role": "Función del usuario",
      "acceptance_state": "Estado"
    },
    "address": {
      "shipping_address_street": "Dirección exterior",
      "shipping_address_city": "Ciudad",
      "address_state": "Estado",
      "shipping_address_state": "Estado",
      "shipping_address_country": "País",
      "shipping_address_zip_code": "Código Postal",
      "billing_address_street": "Dirección exterior",
      "billing_address_city": "Ciudad",
      "billing_address_state": "Estado",
      "billing_address_country": "País",
      "billing_address_zip_code": "Código Postal"
    },
    "contact_info": {
      "contact_first_name": "Nombre",
      "contact_last_name": "Apellido",
      "contact_phone": "Teléfono",
      "contact_email": "Correo electrónico",
      "contact_company": "Empresa",
      "contact_website": "Sitio web",
      "contact_industry": "Sector"
    },
    "formation_request": {
      "name": "Nombre de la organización",
      "requester_organization_id": "Organización del solicitante",
      "shipping_address_street": "Dirección exterior",
      "shipping_address_city": "Ciudad",
      "shipping_address_zip_code": "Código Postal",
      "shipping_address_state": "Estado",
      "shipping_address_country": "País",
      "billing_address_street": "Dirección exterior",
      "billing_address_city": "Ciudad",
      "billing_address_zip_code": "Código Postal",
      "billing_address_state": "Estado",
      "billing_address_country": "País",
      "billing_same_as_shipping": "utilizar la misma dirección para la facturación",
      "contact": "Contacto",
      "location": "Ubicación",
      "created_at": "Creado",
      "contact_first_name": "Nombre del contacto",
      "contact_last_name": "Apellido del contacto",
      "contact_email": "Correo electrónico del contacto",
      "industry": "Sector",
      "acceptance_state": "Estado"
    },
    "user_file": {
      "name": "Nombre del archivo",
      "date_to": "Fecha para",
      "date_from": "Fecha desde",
      "uploaded_by": "Subido por",
      "created_at": "Creado"
    },
    "archive": {
      "serial": "Número de serie",
      "date_to": "Fecha hasta",
      "date_from": "Fecha desde",
      "uploaded_by": "Subido por",
      "created_at": "Creado"
    },
    "parameters": {
      "132:19": "CA",
      "131:10": "CO₂, ppm",
      "132:13": "CH₂O, mg/m³",
      "132:15": "Humedad, %",
      "132:18": "PM, µg/m³",
      "132:4": "PM1, µg/m³",
      "132:6": "PM10, µg/m³",
      "132:5": "PM2.5, µg/m³",
      "132:24": "Temperatura, °F",
      "132:14": "Temperatura, °C",
      "140:11": "COV (EtOH), ppm",
      "140:12": "COV (Isobutileno), ppm"
    }
  },
  "cms_2567": {
    "aecc_categories": {
      "title": "Categorías de Cumplimiento AECC",
      "add_category": "Agregar Categoría AECC",
      "all_added": "Se han agregado todas las categorías AECC disponibles",
      "subcategories_title": "Subcategorías"
    }
  },
  "validation": {
    "backbone": {
      "errors": {
        "required": "{0} is required",
        "acceptance": "{0} must be accepted",
        "min": "{0} must be greater than or equal to {1}",
        "max": "{0} must be less than or equal to {1}",
        "range": "{0} must be between {1} and {2}",
        "length": "{0} must be {1} characters",
        "minLength": "{0} must be at least {1} characters",
        "maxLength": "{0} must be at most {1} characters",
        "rangeLength": "{0} must be between {1} and {2} characters",
        "oneOf": "{0} must be one of: {1}",
        "equalTo": "{0} must be the same as {1}",
        "digits": "{0} must only contain digits",
        "number": "{0} must be a number",
        "email": "{0} must be a valid email",
        "url": "{0} must be a valid url",
        "inlinePattern": "{0} is invalid"
      }
    },
    "errors": {
      "required": "este campo es obligatorio",
      "email": "debe ser un correo electrónico válido",
      "phone": "número de teléfono no válido",
      "min": "%{attr} debe tener por lo menos %{minLength} caracteres",
      "equalTo": "%{attr1} debe ser el mismo que %{attr2}",
      "models": {
        "organization": {
          "attribute": {
            "is_rental": "debe ser de renta"
          }
        },
        "user": {
          "attributes": {
            "phone": "número de teléfono no válido",
            "phone_with_example": "número no válido, ejemplo: %{example}",
            "old_password": "Lo sentimos, la contraseña anterior no coincide"
          }
        }
      }
    }
  }
}